var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('LayoutHeader',{ref:"header"}),_c('div',{staticClass:"layout-content",class:{ isSHow: _vm.isSHow }},[_c('router-view')],1),(_vm.isSHow)?_c('LayoutFooter'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }